import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { functionAppLink } from '../interfaces/function-app-link.interface';
import { FunctionAppInfo } from '../interfaces/function-app-info.interface';

@Injectable({
	providedIn: 'root',
})
export class FunctionAppsLinkService {
	readonly url: string = 'functionAppslink';

	constructor(private http: HttpClient) {}

	public getConfigByCompany(companyId: number): Observable<functionAppLink[]> {
		return this.http.get<functionAppLink[]>(this.url + '/ConfigByCompany/' + companyId);
	}

	public updateLinkCustomAppConfig(functionAppLinkCreateDtos: functionAppsLinkCreateDto): Observable<any> {
		// Send the custom object as a body in a PUT request
		return this.http.post<Observable<any>>(this.url + '/updateLinkCustomAppConfig', functionAppLinkCreateDtos);
	}

	public GetCustomLinkConfigByCompany(companyId: number): Observable<any[]> {
		return this.http.get<any[]>(this.url + '/bulkLinkCustomAppConfig/' + companyId);
	}

	public GetCustomLinkConfigByLink(companyId: number, linkId: number): Observable<any[]> {
		return this.http.get<any[]>(this.url + '/LinkCustomAppConfig/' + companyId + '/' + linkId);
	}
}

export interface functionAppsLinkCreateDto {
	functionAppsIds: number[];
	linkId: number;
}
